import { getHumanizedMaxValue } from '../../helpers/humanization.js';

const getBiznesRegistrationTerms = item => {
    // Поля: Открытие, Онлайн, Без похода в налоговую, РКО от 0руб
    const conditions = [];
    const open = getHumanizedMaxValue({
        from: item.minSum,
        to: item.maxSum,
    }, ' ₽');
    conditions.push({ value: open, description: 'Открытие', key: 'openPrice' });
    const withoutFNS = item.registrationTypes?.includes('noFns');
    conditions.push({ value: withoutFNS ? 'Да' : 'Нет', description: 'Без походов в налоговую', key: 'no-fns' });
    const online = item.registrationTypes?.includes('online');
    conditions.push({ value: online ? 'Да' : 'Нет', description: 'Оформление онлайн', key: 'online' });
    const pko = item.dictAdvantages?.includes('pko');
    conditions.push({ value: pko ? 'Да' : 'Нет', description: 'РКО от 0 руб.', key: 'ot-nolya' });
    return conditions;
};

export { getBiznesRegistrationTerms };
//# sourceMappingURL=businessRegistration.js.map
